export const symbolSize = 16;
export const strokeWidth = 12;
export const arrowSize = 10;
export const arrowStrokeWidth = 4;

export const AudiometrySymbols = {
  AC_RE: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <circle
        cx='50'
        cy='50'
        r='35'
        className='right-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),

  AC_LE: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <path
        d='M 20 20 L 80 80 M 20 80 L 80 20'
        className='left-ear-symbol-stroke'
        strokeWidth={strokeWidth}
      />
    </svg>
  ),

  BC_RE: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <path
        d='
          M 60,20
          L 30,50
          L 60,80
        '
        className='right-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),
  BC_LE: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <path
        d='
          M 40,20
          L 70,50
          L 40,80
        '
        className='left-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),

  AC_RE_MASKING: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <polygon
        points='50,15 85,75 15,75'
        className='right-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),

  AC_LE_MASKING: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <rect
        width='70'
        height='70'
        x='15'
        y='15'
        className='left-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),
  BC_RE_MASKING: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <path
        d='
          M 60,20
          L 25,20
          L 25,80
          L 60,80
        '
        className='right-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),

  BC_LE_MASKING: () => (
    <svg width={symbolSize} height={symbolSize} viewBox='0 0 100 100'>
      <path
        d='
          M 40,20
          L 75,20
          L 75,80
          L 40,80
        '
        className='left-ear-symbol-stroke'
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),
  NO_RESPONSE_RE: ({ color }) => (
    <svg width={arrowSize} height={arrowSize} viewBox='0 0 100 100'>
      <path
        d='M 80 20 L 20 80 M 50 80 L 20 80 L 20 50'
        stroke={color}
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),

  NO_RESPONSE_LE: ({ color }) => (
    <svg width={arrowSize} height={arrowSize} viewBox='0 0 100 100'>
      <path
        d='M 20 20 L 80 80 M 50 80 L 80 80 L 80 50'
        stroke={color}
        strokeWidth={strokeWidth}
        fill='none'
      />
    </svg>
  ),
};

export const getSymbol = (symbolKey) => {
  const SymbolComponent = AudiometrySymbols[symbolKey];
  return SymbolComponent ? <SymbolComponent /> : null;
};

export const {
  AC_RE,
  AC_LE,
  BC_RE,
  BC_LE,
  AC_RE_MASKING,
  AC_LE_MASKING,
  BC_RE_MASKING,
  BC_LE_MASKING,
  NO_RESPONSE_RE,
  NO_RESPONSE_LE,
} = AudiometrySymbols;
